import React from 'react';
import { IoMdClose } from 'react-icons/io';
import './Banner.scss';

export function Banner({
  leftSection,
  content,
  rightSection,
}: {
  leftSection?: React.ReactNode;
  content?: React.ReactNode;
  rightSection?: React.ReactNode;
}) {
  return (
    <div className="banner-container">
      {leftSection && <div className="banner-left">{leftSection}</div>}
      {content && <div className="banner-content">{content}</div>}
      {rightSection && <div className="banner-right">{rightSection}</div>}
    </div>
  );
}

function Title({ children }: { children: React.ReactNode }) {
  return <div className="banner-title">{children}</div>;
}

function VerticalTextSeparator() {
  return <span className="banner-separator" />;
}

function DismissButton({ onClick }: { onClick: () => void }) {
  return (
    <button className="banner-dismiss" onClick={onClick}>
      <span className="pr-5">Dismiss</span>
      <IoMdClose size={22} />
    </button>
  );
}

Banner.Title = Title;
Banner.VerticalTextSeparator = VerticalTextSeparator;
Banner.DismissButton = DismissButton;
